import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function ProtectedRoute({ children, adminOnly = false, staffAllowed = false }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center text-muted-foreground" data-testid="auth-loading">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/conversations" replace />;
  // Staff are restricted to Conversations only. Any other authed route redirects
  // them to /conversations unless the route explicitly opts in via staffAllowed.
  if (!adminOnly && !staffAllowed && user.role !== "admin") return <Navigate to="/conversations" replace />;
  return children;
}
